import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../../app.constant';
import { FilterPoData } from '../../models/filter-data-po';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {
  private frappe: FrappeApp;
  private frappeCall: FrappeCall;
  constructor() {
    this.frappe = new FrappeApp(AppConstant.frappeUrl);
    this.frappeCall=this.frappe.call()
  }


  public getPoList(): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_all_po')
  }
  public getPageablePoList(data:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_pageable_po_list',{ data })
  }

  public filteredPoList(filter:FilterPoData): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.filter_po_data',{data:JSON.stringify(filter)})
  }

  public postDeliverySchedule(schedule:any): Promise<any> {
    return this.frappeCall.post('vendor_portal.api.create-delivery_schedule.create_delivery_schedule',{data:JSON.stringify(schedule)})
  }
  public downloadPoByDate(data:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.download_po_by_date',{data:JSON.stringify(data)})
  }

  public create_po_by_invoice(invoice:any){
    return this.frappeCall.post('vendor_portal.rest.create_po_by_invoice',{invoice})
  }

}
